import { makeCancellableAPIRequest } from "restAPI";
import { BaseResponseDto } from "types/api/baseResponseDto";

import {
  TotpEnrollResponse,
  TotpLoginVerifyRequest,
  TotpStatusResponse,
  TotpSuccessResponse,
} from "../types/totp";

const TotpAPI = {
  verifyLoginTOTP(data: TotpLoginVerifyRequest) {
    return makeCancellableAPIRequest<TotpSuccessResponse>(
      "POST",
      "/api/totp/auth/verify",
      {
        data: {
          ...data,
          enrollmentVerification: false,
        },
      },
      false,
    );
  },

  enrollTOTP() {
    return makeCancellableAPIRequest<BaseResponseDto<TotpEnrollResponse>>(
      "POST",
      "/api/totp/enroll",
    );
  },

  verifyEnrollTOTP(verificationCode: number, email: string) {
    return makeCancellableAPIRequest<BaseResponseDto<string>>(
      "POST",
      "/api/totp/enroll/verify",
      { data: { verificationCode, email, enrollmentVerification: true } },
      false,
    );
  },

  resetTOTP() {
    return makeCancellableAPIRequest<BaseResponseDto<void>>(
      "POST",
      "/api/totp/reset",
    );
  },

  disableTOTP() {
    return makeCancellableAPIRequest<BaseResponseDto<void>>(
      "POST",
      "/api/totp/disable",
    );
  },

  getTOTPStatus() {
    return makeCancellableAPIRequest<BaseResponseDto<TotpStatusResponse>>(
      "GET",
      "/api/totp/status",
    );
  },
};

export default TotpAPI;
